 const  gSettings = { 
    GAME_X_RES: 1024, //1280 // 960
	GAME_Y_RES: 768, //720 // 640 
	GRID_X_POS: 300,
	GRID_Y_POS: 10,
	BACKGROUND_COL:"#3d3d3d", 
	TILE_SIZE: 16,
	TILE_SCALE: 2.35,
	NEXT_BLOCK_TILE_SCALE: 1.5,
	GAME_GRID_SIZE_X: 10,
	GAME_GRID_SIZE_Y: 22,
	SLOW_DROP_DELAY: 60,
	LFRT_DROP_DELAY: 100,
	KEY_HOLD_WAIT_TIME: 400, // 200 is good for me
	SIMPLE_ROTATION: true,
	FADE_ENABLE: true,
	SMOKE_ENABLE: false,
	TOUCH_CONTROLS: true,

	NEXT_BRICK_ALWAYS_IN_CENTER: true, // a respawned brick always starts in the centre
	NO_OF_HIDDEN_TOP_ROWS: 2, // tetris doesn't show the top 
	DRAW_NEXT_AMOUNT: 1, // how many next bricks to display.

	RAT_SCORE_SYSTEM: true,
	LEVEL_PROGRESSION_AMOUNT: 10, // 10 default 
	////// LEVEL SPEEDS
//	            0    1     2     3     4     5     6    7     8     9     10    11   12   13   14   15   16   17   18   19  20 
//LEVEL_SPEEDS: [9999,2000, 1800, 1600, 1500, 1400, 1300, 1200, 1100, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 150, 100, 50],
LEVEL_SPEEDS: [9999,2000, 1500, 1250, 1100, 1000, 900, 850, 800, 750, 700, 650, 600, 550, 500, 400, 300, 200, 150, 125, 75],
LEVEL_COLORS: [0xC0C0C0,0xC0C0C0, 0xff9494, 0xffd794, 0xf9ff94, 0xaaff94, 0x94ffc1, 0x94eeff, 0x94b6ff, 0xb694ff, 0xee04ff, 0xff94d7, 0xaa4e61, 0xaa884e, 0x9baa4e, 0x58aa43, 0x4eaa92, 0x3e92aa, 0x4e58aa, 0x884eaa, 0x595959], // 0xaa4e9b


	///// GAMEPLAY  OPTIONS
	STICKY_BRICKS: false,  // if enabled collisons with bricks on X value will count as a placement
	LINE_CLEAR_DELAY: true, // 
	LINE_CLEAR_DELAY_TIME: 200,
	NO_GRAVITY: false,
	RAT_MODE: true,
	RAT_SPEED: 200, // 300

	///// SCORING
	Score_Single_Line: 100,//× level
	Score_Double_Line: 300, //× level
	Score_Triple_Line: 500, //× level
	Score_Quad_Line:   800, // ×cx level; difficult
	Score_Mini_TSpin_no_line:	100, // × level
	Score_TSpin_no_line:	400, // × level
	Score_Mini_TSpin_Single:	200, //× level; difficult
	Score_TSpin_Single:	800, //x level; difficult
	Score_Mini_TSpin_Double: 	400,// × level; difficult
	Score_TSpin_Double:	1200,// × level; difficult
	Score_TSpin_Triple:	1600,// × level; difficult
	Score_Back_to_Back_difficult_line_clears: 1.5, //	Action score × 1.5 (excluding soft drop and hard drop)
	Score_Combo:	50,// × combo count × level
	Score_Soft_drop : 1,//	1 per cell
	Score_Hard_drop: 2,//	2 per cell
						//  1  2   3   4   5   6   7     8    9    10   11   12   13   14  15    
	Score_Rat_Multi_Bonus: [0,0,100,300,500,800,1200,1700,2500,3400,4400,5500,6700,7800,9200,10000],
	Score_Rat_Value: [100,200,500], // 8 common, 9 uncommon, 10 rare

};

export { gSettings  }





